// Constants for video generation state
export const VIDEO_EXPORT_STATE_ERROR = 'error';
export const VIDEO_EXPORT_STATE_COMPLETED = 'completed';
export const VIDEO_EXPORT_STATE_QUEUED = 'queued';
export const VIDEO_EXPORT_STATE_PROCESSING = 'processing';
export const VIDEO_EXPORT_STATE_UPLOADING = 'uploading';
export const VIDEO_EXPORT_STATE_NOT_FOUND = 'notFound';
